<template>
  <div>
    <Header></Header>
  </div>

  <RouterView></RouterView>

  <div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/views/Header.vue'
import Footer from './components/views/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
